import { render, staticRenderFns } from "./DoubleNumberFramePlacesViewed.vue?vue&type=template&id=43751c70&"
import script from "./DoubleNumberFramePlacesViewed.vue?vue&type=script&lang=js&"
export * from "./DoubleNumberFramePlacesViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports